/* Copyright (C) 2020 SplendidCRM Software, Inc. All Rights Reserved. 
 * Any use of the contents of this file are subject to the SplendidCRM Professional Source Code License Agreement, or other written agreement between you and SplendidCRM ("License"). 
 * SplendidCRM owns all proprietary rights, including all copyrights, patents, trade secrets, and trademarks, in and to the contents of this file.  You will not link to or in any way 
 * combine the contents of this file or any derivatives with any Open Source Code in any manner that would require the contents of this file to be made available to any third party. 
 */

// 1. React and fabric. 
import * as React from 'react';

// https://infinum.com/the-capsized-eight/how-to-use-react-hooks-in-class-components
function useScreenSize(): any
{
	const [width , setWidth ] = React.useState(window.innerWidth );
	const [height, setHeight] = React.useState(window.innerHeight);

	React.useEffect(() =>
	{
		const handler = (event: any) =>
		{
			setWidth (event.target.innerWidth );
			setHeight(event.target.innerHeight);
		};
		window.addEventListener('resize', handler);
		return () =>
		{
			window.removeEventListener('resize', handler);
		};
	}, []);

	return {width, height};
}

const withScreenSizeHook = (Component: any) =>
{
	return (props: any) =>
	{
		const screenSize = useScreenSize();
		return <Component screenSize={ screenSize } {...props} />;
	};
};

export default withScreenSizeHook;
